const isAllowedUrl = function(url) {
    const allowedUrls = [
        '/search',
        '/business/support',
        '/support',
    ]

    let allowed = false

    allowedUrls.forEach((validUrl) => {
        if (url.includes(validUrl)) {
            allowed = true
            return
        }
    })

    return allowed
}

export {
    isAllowedUrl,
}
